export function removeDigitsFromFormatted(formatted: string): string {
    return formatted.replace(/\D/g, '');
}
